<template>
  <div class="profile-choose-type">
    <div class="profile-choose-type__title">Выберите тип профиля:</div>
    <div class="profile-choose-type__list">
      <Btn
        class="profile-choose-type__item"
        v-for="type in getProfileTypeList"
        :key="type.id"
        :title="type.name"
        @click="chooseCreateType(type.id)"/>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import Btn from '../../form/Btn'

  export default {
    name: 'ProfileTypeChoose',
    components: {
      Btn
    },
    computed: {
      ...mapGetters('profile', [
        'getProfileTypeList'
      ])
    },
    methods: {
      ...mapActions('profile', [
        'chooseCreateType'
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Personal/PersonalProfile/ProfileTypeChoose.vue